/**
 * @generated SignedSource<<93edf66cf22131d109b2e3919320b3a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainSubTodos_todo$data = {
  readonly subTodos: ReadonlyArray<{
    readonly id: string;
    readonly status: TodoStatus;
    readonly " $fragmentSpreads": FragmentRefs<"TodoListItemSubTodo_todo">;
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainPreventDefault_todo">;
  readonly " $fragmentType": "TodoEditNewMainSubTodos_todo";
};
export type TodoEditNewMainSubTodos_todo$key = {
  readonly " $data"?: TodoEditNewMainSubTodos_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainSubTodos_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainSubTodos_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Todo",
      "kind": "LinkedField",
      "name": "subTodos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoListItemSubTodo_todo"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainPreventDefault_todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "4e146e3a58ea90db29a57df1106722a2";

export default node;
